import React from "react";
import styles from "./Header.module.css";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import languages from "languages/languages";
import * as actionTypes from "store/actions/actionTypes";
import gobackImg from "assets/images/goback.svg";
import flag_en from "assets/images/flag-en.svg";
import flag_vi from "assets/images/flag-vi.svg";
import playClickSpecial from "utils/playClickSpecial";
// import { getInitScreen } from "utils/localStorage";
// import { screenKeys } from "config/constants";

const Header = ({ goBack, loading }) => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const langState = useSelector((state) => state.language.lang);
  const startScreenState = useSelector((state) => state.settings.startScreen);
  const [timeString, setTimeString] = React.useState("");

  // const [clickCount, setClickCount] = React.useState(0);
  const handleBack = (event) => {
    event.preventDefault();
    playClickSpecial(true);
    if (!id) {
      dispatch({ type: actionTypes.CLEAR_ALL_FILTER });
    }

    if (goBack) {
      history.push("/" + goBack);
    }
  };

  const handleSwitchLang = (e) => {
    if (loading) {
      return;
    }

    //new spec: always go back to top screen when change language
    if (e.target.value && e.target.value !== langState) {
      playClickSpecial();
      dispatch({ type: actionTypes.SET_LANGUAGE, payload: e.target.value });
      dispatch({ type: actionTypes.CLEAR_ALL_FILTER });
      history.push("/" + startScreenState);
    }
  };

  const handleResetData = () => {
    localStorage.removeItem("initScreen");
    localStorage.removeItem("mapOrientation");
    localStorage.removeItem("deviceFloorLevel");
    localStorage.removeItem("deviceSvgId");
    setTimeout(() => {
      window.location.href = "/";
    }, 500);
  };

  // const handleResetSetting = () => {
  //   setClickCount(prev => (prev + 1));
  // };

  // const debounceRef = React.useRef(null);

  // React.useEffect(() => {
  //   if (clickCount) {
  //     if (debounceRef.current) {
  //       clearTimeout(debounceRef.current);
  //       debounceRef.current = setTimeout(() => {
  //         setClickCount(0);
  //         debounceRef.current = null
  //       }, 5000);
  //     } else {
  //       debounceRef.current = setTimeout(() => {
  //         setClickCount(0);
  //         debounceRef.current = null
  //       }, 5000);
  //     }

  //     if (clickCount >= 10) {
  //       history.push('/' + screenKeys.config);
  //       setClickCount(0);
  //     }
  //   }
  // }, [clickCount]);

  // [NEW SPEC] - Display time for Foodcoast
  const formatTime = (date) => {
    if (!date) return "";
    const hours = `0${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);
    return `${hours}:${minutes}`;
  };

  React.useEffect(() => {
    const clockInterval = setInterval(() => {
      const current = new Date();
      const newTimeString = formatTime(current);
      setTimeString(newTimeString);
    }, 1000);
    return () => {
      clearInterval(clockInterval);
    };
  }, []);
  //const localScreen = getInitScreen();
  // \\ [NEW SPEC] - Display time for Foodcoast

  return (
    <header className={styles.wrapp_header}>
      <div className="container-fluid">
        <div
          className={
            styles.customHeader +
            " d-flex justify-content-between align-items-center"
          }
        >
          <div>
            {goBack && (
              <div className={styles.btn_goback}>
                <a onClick={handleBack} href="#">
                  <img src={gobackImg} alt="" />{" "}
                  {languages[langState]["Quay lại"]}
                </a>
              </div>
            )}
          </div>

          <div className={styles.clock_display}>{timeString}</div>

          {/* <button type="button" className="transparent" onClick={handleResetSetting} >Go To Config</button> */}
          <div className="language text-right">
            <button
              className={
                styles.language_button +
                " " +
                (langState === "vi" ? styles.active : "")
              }
              value="vi"
              onClick={handleSwitchLang}
            >
              {/* <img src={flag_vi} alt="tieng viet" /> */}
              Tiếng Việt
            </button>
            <button
              className={
                styles.language_button +
                " " +
                (langState === "en" ? styles.active : "")
              }
              value="en"
              onClick={handleSwitchLang}
            >
              {/* <img src={flag_en} alt="english" /> */}
              English
            </button>
            <button
              style={{
                background: "transparent",
                border: "none",
                marginLeft: 10,
                color: "transparent",
              }}
              onClick={handleResetData}
            >
              x
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
